import { MaritalStatuses } from '../../../../global/constants/lists';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';
import { Person } from '../../../../global/models/person-model';
import { RelationshipsProps } from '../../models/account-info-epi-props';
import { Spouse } from '../relationships/relationships-model';

export function mapErrorToMaritalKey(errorKey: string) {
	switch (errorKey) {
		case 'preliminary_date_of_death':
		case 'end_date':
			return 'marriage_end_date';
		case 'start_date':
			return 'marital_status_effective_date';
		default:
			return errorKey;
	}
}

export function GetAttestation1Label(app: DemographicAppKeys, settings: RelationshipsProps) {
	return app === DemographicAppKeys.myCPG ? settings?.attestationLabel1 : settings?.mapAttestationLabel1;
}

export function GetAttestation2Label(app: DemographicAppKeys, settings: RelationshipsProps) {
	return app === DemographicAppKeys.myCPG ? settings?.attestationLabel2 : settings?.mapAttestationLabel2;
}

export function getCurrentMaritalStatus(currentPerson: Person, spouse: Spouse) {

	if (spouse?.date_of_death) {
		return MaritalStatuses.Widowed;
	}

	if (spouse?.legal_separation_date && currentPerson.marital_status === MaritalStatuses.Married ) {
		return MaritalStatuses.Married;
	}

	return currentPerson.marital_status || (spouse ? MaritalStatuses.Married : MaritalStatuses.Single);
}